import React, { useState, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Button, Table, Alert, Spinner, Form, InputGroup, Badge, Card } from 'react-bootstrap'
import { useAdminSystems } from 'api/hooks/use-admin-systems'

const SystemsList = () => {
  const { data: systems, isLoading, error } = useAdminSystems()
  const [searchTerm, setSearchTerm] = useState('')

  const filteredSystems = useMemo(() => {
    if (!systems) return []
    return systems.filter((sys) => {
      const term = searchTerm.toLowerCase()
      return (
        sys.name?.toLowerCase().includes(term) ||
        sys.company?.toLowerCase().includes(term)
      )
    })
  }, [systems, searchTerm])

  if (isLoading) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    )
  }

  if (error) {
    return <Alert variant="danger">Error loading systems: {error.message}</Alert>
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Systems</h2>
        <Button as={Link} to="/admin/systems/new" variant="primary">Create System</Button>
      </div>

      <Card className="mb-4">
        <Card.Body>
          <InputGroup>
            <InputGroup.Text>Search</InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Search by name or company..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </InputGroup>
        </Card.Body>
      </Card>

      <div className="mb-3">
        <strong>Showing {filteredSystems.length} of {systems?.length || 0} systems</strong>
      </div>

      <Table bordered hover responsive>
        <thead>
          <tr>
            <th>Name</th>
            <th>Company</th>
            <th>System Table Columns</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredSystems.map((sys) => (
            <tr key={sys.id}>
              <td>{sys.name}</td>
              <td>{sys.company || '-'}</td>
              <td><Badge bg="primary">{sys.system_table_columns_count}</Badge></td>
              <td>
                <Button as={Link} to={`/admin/systems/${sys.id}`} variant="info" size="sm" className="me-2">View</Button>
                <Button as={Link} to={`/admin/systems/${sys.id}/edit`} variant="warning" size="sm">Edit</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {filteredSystems.length === 0 && <Alert variant="info">No systems found.</Alert>}
    </div>
  )
}

export default SystemsList
